import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/constants/content";

export const FAQ = () => (
  <section id="faq" className="cp-section cp-section--white" data-testid="faq-section">
    <div className="cp-container cp-faq-wrap">
      <Reveal className="cp-section-head">
        <span className="cp-eyebrow">FAQ</span>
        <h2 className="cp-h2">Frequently Asked Questions</h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="cp-faq" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="cp-faq-item" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="cp-faq-trigger" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="cp-faq-content">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
